jQuery(document).ready(function ($) {
  var $customer = $(".box-carousel-customer .swiper");

  if (!$customer.length) return;

  $customer.each(function (index, element) {
    var mySwiper = new Swiper(element, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 2,
      spaceBetween: 10,
      speed: 500,
      // loop: true,
      rewind: true,
      // centerInsufficientSlides: true,
      navigation: {
        nextEl: $(element).parent().find(".carousel-navigation .next")[0],
        prevEl: $(element).parent().find(".carousel-navigation .prev")[0],
      },
      breakpoints: {
        576: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 7,
          spaceBetween: 30,
        },
      },
    });
  });
});
